// extracted by mini-css-extract-plugin
export default {"detail":"DetailTitle_detail__N1vOM","detailTitle":"DetailTitle_detailTitle__4MxS4","detailData":"DetailTitle_detailData__bfgaL"};